export const isAndroidPOS = () => {
  return (
    typeof window !== 'undefined' &&
    window.AndroidPOS &&
    typeof window.AndroidPOS.isAndroidPOS === 'function' &&
    window.AndroidPOS.isAndroidPOS() === true
  );
};

export const isOfflineAndroid = () => {
  return (
    isAndroidPOS() &&
    typeof window.AndroidPOS.isOfflineMode === 'function' &&
    window.AndroidPOS.isOfflineMode() === true
  );
};

export const isAuthenticated = () => {
  const token =
    localStorage.getItem('accessToken') ||
    sessionStorage.getItem('accessToken');

  const offlineMode =
    localStorage.getItem('offline_mode') === '1';

  return Boolean(
    token ||
    (offlineMode && isOfflineAndroid())
  );
};
